// these functions call the global Success and pyError functions (from tools.js) to display the result of the request

export const showSuccess = () => {
	window["Success"]();
};

export const showError = (message = "") => {
	window["pyError"](message);
};
